import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getStudent } from '../services/scpApi';

export const fetchStudent = createAsyncThunk('portalSelected/fetchStudent', async (studentId) => {
    try {
        const student = await getStudent(studentId);
        console.log('Fetched student:', student);
        return student;
    } catch (error) {
        console.error('Failed to fetch student:', error);
    }
});

export const portalSelectedSlice = createSlice({
    name: 'portalSelected',
    initialState: {
        selectedStudent: null,
        selectedSchool: null,
        selectedYearGroup: null,
    },
    reducers: {
        setSelectedStudent: (state, action) => {
            state.selectedStudent = action.payload;
        },
        clearSelectedStudent: (state) => {
            state.selectedStudent = null;
        },
        setSelectedSchool: (state, action) => {
            state.selectedSchool = action.payload;
        },
        setSelectedYearGroup: (state, action) => {
            state.selectedYearGroup = action.payload;
        },
        clearAllSelections: (state) => {
            state.selectedStudent = null;
            state.selectedSchool = null;
            state.selectedYearGroup = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStudent.fulfilled, (state, action) => {   
                state.selectedStudent = action.payload;
                console.log('Student fetched and stored in state:', action.payload);
            })
    }
});

export const {
    setSelectedStudent,
    clearSelectedStudent,
    setSelectedSchool,
    setSelectedYearGroup,
    clearAllSelections
} = portalSelectedSlice.actions;

export default portalSelectedSlice.reducer;
